import VideoPlayer from "../VideoPlayer";
import { useNavigate } from 'react-router-dom';
import './results.css';

const Short = ({ item }) => {
  const navigate = useNavigate();
  const { thumbnail, title, reason, viral_score, clips, startTimestamp, endTimestamp, video_url } = item;

  const formatDuration = (start, end) => {
    const durationInSeconds = Math.floor((end || 0) - (start || 0));
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = durationInSeconds % 60;
    const mm = minutes.toString().padStart(2, "0");
    const ss = seconds.toString().padStart(2, "0");
    return hours > 0 ? `${hours}:${mm}:${ss}` : `${mm}:${ss}`;
  };

  // Position the thumbnail using the first clip's horizontal offset (as before).
  let offset_x = 0;
  if (clips && clips[0]) offset_x = clips[0].offset_x || 0;
  const scaleFactor = 258 / 1920;
  const imageStyle = { objectPosition: `${offset_x * scaleFactor}px center` };

  return (
    <div className="scr-card">
      <div className="scr-media">
        {video_url
          ? <VideoPlayer src={video_url} poster={thumbnail} />
          : <img src={thumbnail} alt={title} style={imageStyle} />}
        {viral_score != null && (
          <div className="scr-score"><b>{viral_score}</b><span>Score</span></div>
        )}
        {(startTimestamp != null && endTimestamp != null) && (
          <div className="scr-dur">{formatDuration(startTimestamp, endTimestamp)}</div>
        )}
      </div>

      <div className="scr-body">
        <h3>{title}</h3>
        <p>{reason}</p>
      </div>

      <div className="scr-foot">
        <button
          className="scr-upload"
          title="Upload to TikTok, YouTube Shorts, or Instagram Reels"
          onClick={() => navigate('/upload', { state: { ShortsMakerField: item } })}
        >
          Upload to Social Media
        </button>
      </div>
    </div>
  );
};

export default Short;
